<div class="footer-section">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="col-12 footer-title">CEPLAN</div>
                <div class="col-12 footer-parraf">Es el organismo técnico especializado que ejerce la función de órgano
                    rector, orientador y de coordinación del Sistema Nacional de Planeamiento Estratégico; orientado al
                    desarrollo de la planificación estratégica como instrumento técnico de gobierno y gestión para el
                    desarrollo armónico y sostenido del país y el fortalecimiento de la gobernabilidad democrática en el
                    marco del Estado constitucional de derecho.</div>
                <br>
                <a class="col-12 footer-parraf" href="https://www.gob.pe/ceplan"><i class="fa fa-globe"></i> CEPLAN</a>
            </div>
            <div class="col-md-4">
                <div class="col-12 footer-title">Enlaces de interés</div>
                <ul>
                    <li><a href="https://www.ceplan.gob.pe/modulo-de-consultas/">Módulos de consulta</a></li>
                </ul>
                <ul>
                    <li><a href="https://www.ceplan.gob.pe/publicaciones/">Publicaciones</a></li>
                </ul>
                <!-- <ul>
                    <li><a href="http://geo.ceplan.gob.pe/">Plataforma de información territorial</a></li>
                </ul> -->
                <br>
                <div class="col-12 footer-title">Últimas actividades</div>
            </div>
            <div class="col-md-4">
                <div class="col-12 footer-title">Contacto</div>
                <div class="col-12">
                    <ul class="list-unstyled">
                        <li><i class="fa fa-map-marker"></i> Dirección:<br> Av. Canaval y Moreyra 480 - Piso 21 -
                            Edificio Chocavento. San Isidro, Lima, Perú.<br><br></li>
                        <li><i class="fa fa-clock-o"></i> Horario de Atención al Público:</li>
                        <li>Lunes a Viernes</li>
                        <li>8:30 - 13:00h / 14:00 - 17:30h<br><br></li>                        
                        <li><img src="assets/img/number_contact.svg" class="icon-number"> Consultas Observatorio: <br></li>
                        <li> (01) 211-7811</li>
                        <li> 982 085 294</li>
                        <li>observatorio&#64;ceplan.gob.pe</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>